export const US_CENTER = {
  lat: 39.8097343,
  lng: -98.5556199,
};

export const INFO_WINDOW_TIMEOUT = 500;
